<ng-select (change)="onChange($event)"
           [(ngModel)]="schoolLocationValue"
           [items]="schoolLocations"
           [loading]="loading"
           [selectableGroup]="false"
           bindLabel="school_short_address"
           groupBy="school_name"
           [disabled]="isDisabled"
           class="selector-style"
           placeholder="{{schoolLocationValue ? '' : (all ? 'ALL' : 'SELECT') | translate}} {{ schoolLocationValue ? '' : 'SCHOOL_LOCATION' | translate }}">
    <ng-template ng-option-tmp let-item="item" let-index="index">
        <div [ngClass]="{'custom-option-style': true, 'disabled-option': isDisabled}">
            {{ item.school_short_address }}
        </div>
    </ng-template>

    <ng-template ng-optgroup-tmp let-item="item">
        <div class="group-style">{{ item.school_name || 'Unnamed group' }}</div>
    </ng-template>
</ng-select>
